import { render } from "./truck.vue?vue&type=template&id=0a317578&scoped=true"
import script from "./truck.vue?vue&type=script&lang=js"
export * from "./truck.vue?vue&type=script&lang=js"

import "./truck.vue?vue&type=style&index=0&id=0a317578&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a317578"]])

export default __exports__